import { ChevronDown, Paperclip } from "lucide-react";
import { useState } from "react";
import PrivateAttachment from "@/components/PrivateAttachment";

export default function RequestScopeAccordion({ problem }) {
  const [open, setOpen] = useState(false);

  return (
    <section className="rounded-2xl border border-brand-line bg-white" data-testid="request-scope-accordion">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
        aria-expanded={open}
      >
        <span className="inline-flex items-center gap-2 font-medium text-brand-ink">
          Opgavens omfang
          <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`}/>
        </span>
        <span className="text-sm font-medium text-brand-green">{open ? "Skjul detaljer" : "Vis detaljer"}</span>
      </button>

      {open && (
        <div className="border-t border-brand-line px-5 py-4">
          <p className="text-sm leading-6 text-brand-body whitespace-pre-wrap">{problem.description}</p>
          {problem.what_tried && (
            <div className="mt-4">
              <div className="text-[11px] uppercase tracking-wider text-brand-muted">Det har jeg allerede prøvet</div>
              <p className="mt-1 text-sm leading-6 text-brand-body whitespace-pre-wrap">{problem.what_tried}</p>
            </div>
          )}
          {problem.media?.length > 0 && (
            <div className="mt-4">
              <div className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-brand-muted">
                <Paperclip size={12}/> Vedhæftninger
              </div>
              <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-4">
                {problem.media.map((media, index) => (
                  <PrivateAttachment
                    key={media.id || index}
                    attachment={{
                      ...media,
                      url: media.url?.startsWith("/api/") ? media.url.slice(4) : (media.url || media.dataUrl),
                      content_type: media.content_type || media.type,
                      name: media.name || `Vedhæftning ${index + 1}`,
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

